export const SHEET_Z_DEFAULT = 1400
export const SHEET_Z_NESTED = 10120
export const SHEET_Z_GLOBAL = 10130
export const SHEET_Z_PICKER = 10140

export const CHAT_PANEL_Z = 1001

/**
 * The sheet panel — THEME-FOLLOWING since Phase 2 step 2f (the light-theme
 * cutover): the forced `dark` class is gone, so the `--sheet*` tokens resolve
 * per the site theme — light panel on a light site, `#171717` (the former
 * hardcoded literal, `bg-neutral-900`) under `.dark`.
 *
 * The cutover removed `dark` from FIVE points at once: this constant,
 * `DIALOG_CARD_CONTENT_BASE`, `DIALOG_CARD_CONTENT_BASE_NESTED` (feeds the
 * `AlertDialogContent` primitive — invisible in consumer files), the
 * `selection-bar` wrapper, and the desktop cart drawer (`cart.tsx`).
 * Rollback = put `dark` back in the same five places.
 *
 * Name kept through the flip so the rollback stays a one-word diff; renaming
 * (`_DARK` no longer describes it) is a follow-up, not part of 2f.
 *
 * Anything PORTALED out of the panel (Radix menus, dialogs) lands on
 * `document.body` and themes itself — see `DROPDOWN_CHROME_SURFACE_CLASS`,
 * which paints the same `--sheet*` tokens so the menu matches the panel it
 * dropped out of (theme-following too, since the 2f acceptance pass).
 *
 * @see .tondocs/ui/HANDOFF_SHEET_LIGHT_THEME_2026_08_01.md §4.1 (flip points), §7
 * @see .tondocs/ui/THEMING.md § "The gotcha: Tailwind v4 `@theme` + scoped `.dark`"
 */
export const SHEET_PANEL_DARK = "bg-sheet text-sheet-foreground rounded-t-3xl overflow-hidden"
/** Dims the PAGE under the panel — correct in BOTH themes, and the contrast a
 *  white panel will lean on after 2f. Not a `--sheet*` surface; do not tokenise. */
export const SHEET_BACKDROP = "bg-black/40 backdrop-blur-xl"
export const SHEET_HEADER_HANDLE = "w-9 h-1 rounded-full bg-sheet-handle"
export const SHEET_RADIUS_TOP = "rounded-t-3xl"
export const SHEET_STANDARD_HEIGHT = "90dvh"
